<template>
<v-scale-screen width="1920" height="1080" :fullScreen="true" >
    <div id="monitoringLeft">
        <div class="left_header">
           <div class="header_left">
                <img @click="goHome('home')" src="../../assets/images/monitoring/header_left1.png">
                <span  @click="goHome('home')">首页</span>
               <img src="../../assets/images/monitoring/header_left2.png">
               <!-- <span>2023年06月22日 星期四 15:01:34 </span> -->
               <span>{{ nowDate + " "  + nowWeek +"  " + nowTime}}</span>
           </div>
           <div class="header_right">
                <img src="../../assets/images/monitoring/header_left3.png">
                <span>地区：北京  天气：{{ tq.tqxx }} 风向：{{ tq.fxms }} 空气质量：{{ tq.kqzl }}</span>
                <img src="../../assets/images/monitoring/header_left4.png">
                <span>{{userInfo.userName}}</span>
                <img @click="loginOut" src="../../assets/images/monitoring/header_left5.png">
                <span @click="loginOut">退出</span>
           </div>
        </div>
        <div class="left_main">
            <div class="main_one">
                <div class="one_div" style="pointer-events: auto;">
                    <div  class="div_main" v-for="(item,index) in List" :key="index" :style="{ background: `url(${item.imgUrl}) no-repeat ` }">
                        <div style="color:#0096FF;font-size:0.18rem;">{{item.grade}}</div>
                        <div style="color:#E8F4FF;font-size:0.1rem;">{{item.name}}</div>
                    </div>
                </div>
                <div class="two_div" >
                    <div style="pointer-events: auto;" class="div_main" v-for="(item,index) in List2" :key="index" :style="{ background: `url(${item.imgUrl}) no-repeat ` }">
                        <div style="color:#0096FF;font-size:0.18rem;">{{item.grade}}</div>
                        <div style="color:#E8F4FF;font-size:0.1rem;">{{item.name}}</div>
                    </div>
                </div>
                <div class="three_div">
                    <div style="pointer-events: auto;" class="three_main" v-for="(item,index) in List3" :key="index">
                        <img :src="item.imgUrl">
                        <div style="color:#BCCAF3;font-size:0.12rem;float:left;padding-top: 0.05rem;">{{item.name}}</div>
                        <div style="color:#BCCAF3;font-size:0.12rem;">{{item.name2}}</div>
                    </div>
                </div>
                <div class="four_div">
                    <div style="pointer-events: auto;" class="four_main" v-for="(item,index) in List4" :key="index">
                        <img :src="item.imgUrl">
                        <div class="">
                            <div style="color:#40ECC2;font-size:0.14rem;padding-top: 0.05rem;">{{item.name}}</div>
                            <div style="color:#BCCAF3;font-size:0.12rem;">{{item.name2}}</div>
                        </div>
                    </div>
                </div>
                <div class="four_div">
                    <div style="pointer-events: auto;" class="four_main" v-for="(item,index) in List5" :key="index">
                        <img :src="item.imgUrl">
                        <div class="" >
                            <div style="color:#40ECC2;font-size:0.14rem;padding-top: 0.05rem;">{{item.name}}</div>
                            <div style="color:#BCCAF3; font-size:0.12rem;">{{item.name2}}</div>
                        </div>
                    </div>
                </div>
                <div class="four_div">
                    <div style="pointer-events: auto;" class="four_main" v-for="(item,index) in List6" :key="index">
                        <img :src="item.imgUrl">
                        <div class="">
                            <div style="color:#40ECC2;font-size:0.14rem;padding-top: 0.05rem;">{{item.name}}</div>
                            <div style="color:#BCCAF3;font-size:0.12rem;">{{item.name2}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main_two" style="width: 4rem;pointer-events: auto;" >
                <div class="two_div" style="pointer-events: auto;">
                    <div class="div_main">
                        <div style="float:left;">政策名称</div>
                        <div style="float:right;">时间</div>
                    </div>
                </div>
                <div style="pointer-events: auto;" class="two_div" v-for="(item,index) in List7" :key="index" :style="{ background: `url(${item.imgUrl}) no-repeat ` }">
                    <div class="div_main">
                        <div style="float:left; width: 2.35rem; white-space: nowrap;  overflow: hidden; text-overflow: ellipsis;">{{item.noticeTitle}}</div>
                        <div style="float:right;">{{ item.releaseDate }}</div>
                    </div>
                </div>
                <!-- <div class="one_title" style="width:5.71rem;margin-left:1.2rem !important;">
                    分地区场站统计
                </div> -->
                <div id="two_footer" >
                </div>
            </div>
        </div>
        <div class="center_main" id="bmap"></div>
        <div class="main_cz" >
            <div class="" @click="sxDialogShow">
                <img src="../../assets/images/monitoring/dtcz.png" alt="">
            </div>
            <div class="main_czsx" v-if="sxDialog">
                <div class="czsx_title">
                    <img src="../../assets/images/monitoring/sxfzx.png">&nbsp;&nbsp;
                    分中心
                </div>
                <div class="czsx_div">
                    <div v-for="(item,index) in fzxList" :key="index" @click="fzxClick(item)" >
                       <span :class="fzxId==item.id? 'searchText':''" > {{item.companyName}}</span>
                    </div>
                </div>
                <div class="czsx_title">
                    <img src="../../assets/images/monitoring/sxcqdw.png">&nbsp;&nbsp;
                    产权单位
                </div>
                <div class="czsx_div">
                    <div style="width:1.5rem;" v-for="(item,index) in cqdwList" :key="index" @click="cqdwClick(item)">

                        <span :class="cqdwId==item? 'searchText':''">{{item}}</span>
                    </div>
                </div>
                <div class="czsx_title">
                    <div class="screen-subtitle">
                    <img src="../../assets/images/monitoring/sxcz.png">&nbsp;&nbsp;
                        场站
                    </div>
                    <div class="search">
                        <el-input v-model="stationName" placeholder="请根据关键词进行搜索"></el-input>
                        <el-button type="primary" icon="el-icon-search" @click="searchStation">搜索</el-button>
                    </div>
                    <div class="czsx_div">
                        <div style="width:2.05rem;margin-right:0.05rem;" v-for="(item,index) in stationData" :key="index" @click="stationSearchClick(item)">
                            <span >{{item.stationName}}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="dialog-footer">
                    <button>取消</button>
                    <button>确定</button>
                </div> -->
                <div class="" style="position: absolute; top:20px; right: 0.2rem;">
                    <i class="el-icon-close" @click="sxDialogShow" style="font-size: 16px;"></i>
                </div>
            </div>
             <div class="main_tq">
                <div class="tq_feng" v-if="tq.tqxx=='大风'">
                    <div class="feng_name">
                        {{'大风'}}
                    </div>
                </div>
                <div class="tq_feng" v-if="tq.tqxx=='暴雨'">
                    <div class="feng_name">
                        {{'暴雨'}}
                    </div>
                </div>
            </div>
        </div>
        <div class="pop-ups" v-if="mapDialog">
          <div class="dialog-title">
            <img src="../../assets/images/cockpit/mark.png" alt="" />
            <p>{{mapObj.stationName}}</p>
          </div>
          <ul class="dialog-content">
            <li class="year-electricity">
              <div>
                <span>{{ mapObj.yearPower }}</span>
                <p>年总用电量 (GWh)</p>
              </div>
            </li>
            <li class="dialog-form">
              <div>管理中心:</div>
              <p>{{mapObj.companyName}}</p>
            </li>
            <li class="dialog-form">
              <div>场站编码:</div>
              <p>{{mapObj.stationNumber}}</p>
            </li>
            <li class="dialog-form">
              <div>设备总数:</div>
              <p>{{ mapObj.equipmentCount }}</p>
            </li>
            <li class="dialog-form">
              <div>当月用电量:</div>
              <p>{{mapObj.monthlyElectricityQuantity}}kWh</p>
            </li>
            <li class="dialog-form">
              <div>昨日用电量:</div>
              <p>{{mapObj.yesterdayElectricity }}kWh</p>
            </li>
            <!-- <li class="dialog-form">
              <div>查看视频:</div>
              <img style="margin-left: 16px" src="../../assets/images/cockpit/camera.png" alt="" />
            </li> -->
            <li>
              <button style="cursor:pointer;" @click="goDetail()">查看详细 >></button>
            </li>
          </ul>
        </div>
        <div class="right_main">
            <div class="main_one">
                <div id="one_echarts">
                    
                </div>
                <div class="one_title" style="width:5.71rem;">
                    配电形式情况统计
                </div>
                <div id="two_echarts">

                </div>
            </div>
            <div class="main_two" style="z-index:1990">
                <el-select  class="custom-select" clearable  v-model="dictType" :popper-append-to-body="false" style="z-index:1990;position: absolute;
                    right: 50px;
                    top:40px;
                    width: 0.9rem;
                    border:1px solid #0E447E;" placeholder="请选择" @change="dictChange">
                        <el-option
                        v-for="item in dictList"
                        :key="item.dictValue"
                        :label="item.dictName"
                        :value="item.dictValue">
                        </el-option>
                    </el-select>
                <div id="three_echarts" :class="`backg${dictType}`" >
                </div>
                <div class="one_title" style="width:5.71rem;margin-left:1.2rem !important;">
                    <!-- 分地区场站统计 -->{{ value==1? '分地区': '分中心' }}场站统计
                </div>
                <el-select class="custom-select"  v-model="value" :popper-append-to-body="false" style="z-index:1990;position: absolute;
                    right: 50px;
                    top:240px;
                    width: 0.9rem;
                    border:1px solid #0E447E;" placeholder="请选择" @change="stationChange">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                <div id="four_echarts">

                </div>
            </div>
        </div>
        <div class="total-electricity">
          <div class="text">
            <img style="margin-right:0.1rem;" src="../../assets/images/monitoring/nyjkzts.png" alt="" />
            <span>能源监控总天数</span>
          </div>
          <ul class="total">
            <!-- <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li> -->
            <li v-for=" (item , index ) in timeDays" :keys="index">{{ item }}</li>
          </ul>
        </div>
        <div class="right_nav" @click="jump()">

        </div>
        <div class="monitoringFooter"></div>
    </div> 
</v-scale-screen>
</template>
<script>
import moment from "moment";
import "moment/locale/zh-cn"; // 引入中文语言包
import {monitoringLeftApi} from '@/api/monitoringLeft.js'
import * as echarts from "echarts";
import L from 'leaflet';
import data from '@/api/china.json'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import mapstyle from '../../assets/js/style'
import { getWeatherHourData } from "@/api/map.js";
export default {
    data(){
      return{
      
          map:null,
          sxDialog:false,
          mapDialog:false,
          value:2,
          timeDays:[],
          options:[
            {label:'分中心',value:2},
            { label:'地区',value:1},
          ],
          dictList:[],
          dictType:'',
          mapstyle:[],
          userInfo:{},
          stationName:'',
          tq:{
              feng:'',
              yu:''
          },
          statistics:{},
          List:[
          {
                  imgUrl:require('../../assets/images/monitoring/glzx.png'),
                  grade:'',
                  name:'管理中心 (个)'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/cz.png'),
                  grade:'',
                  name:'场站 (个)'
              },
             
          ],
        
          List2:[
              {
                  imgUrl:require('../../assets/images/monitoring/co2.png'),
                  grade:'',
                  name:'CO2排放量 (万吨)'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/jsbzm.png'),
                  grade:'',
                  name:'等效植树(棵)'
              },
          ],
          List3:[
              {
                  imgUrl:require('../../assets/images/monitoring/zydl.png'),
                  name:'总用电量',
                  name2:'(Gwh)'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/zysl.png'),
                  name:'总用水量',
                  name2:'(kt)'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/zyql.png'),
                  name:'总用气量',
                  name2:'0(Nm³)'
              },
          ],
          List4:[
              {
                  imgUrl:require('../../assets/images/monitoring/yearDian.png'),
                  name:'5465.8',
                  name2:'当年'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/yearShui.png'),
                  name:'0',
                  name2:'当年'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/yearQi.png'),
                  name:'0',
                  name2:'当年'
              },
          ],
          List5:[
              {
                  imgUrl:require('../../assets/images/monitoring/monthDian.png'),
                  name:'354',
                  name2:'当月'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/monthShui.png'),
                  name:'0',
                  name2:'当月'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/monthQi.png'),
                  name:'0',
                  name2:'当月'
              },
          ],
          List6:[
              {
                  imgUrl:require('../../assets/images/monitoring/dayDian.png'),
                  name:'5465.8',
                  name2:'当日'  
              },
              {
                  imgUrl:require('../../assets/images/monitoring/dayShui.png'),
                  name:'0',
                  name2:'当日'
              },
              {
                  imgUrl:require('../../assets/images/monitoring/dayQi.png'),
                  name:'0',
                  name2:'当日'
              },
          ],
          List7:[
              {
                  value:'公交集团工会职工文体活动奖品集中采购项...',
                  imgUrl:require('../../assets/images/monitoring/xwdt1.png')
              },
              {
                  value:'1815座公交电子站牌实现通电',
                  imgUrl:require('../../assets/images/monitoring/xwdt1.png')
              },
              {
                  value:'集团公司完成庆祝建党100周年大会运输保障',
                  imgUrl:require('../../assets/images/monitoring/xwdt1.png')
              },
              {
                  value:'企业新型学徒制培训课程资源建设项目中标...',
                  imgUrl:require('../../assets/images/monitoring/xwdt1.png')
              }
          ],
          fzxList:[],
          cqdwList:[],
          stationData:[],
          fzxId:'',
          cqdwId:'',
          stationId:'',
          nowDate: "", // 当前日期
      nowTime: "", // 当前时间
      nowWeek: "", // 当前星期
      
        }
    },  
    mounted(){
        this.setWeather()
        
        this.userInfo = JSON.parse(sessionStorage.getItem('user_info'));
        this.currentTime()

        this.getTime()
        this.setchart1()
        this.setchart2()
        this.setchart3()
        this.setchart4()
        this.setchart5()
        this.stationDialog()
        // window.addEventListener('resize', () => {
        //     // 当浏览器缩放发生变化时，重新设置地图中心点和缩放级别
        //     this.map.updateSize();
        // });
        this.energyStations()
        this.queryDictionary()
   

    },
    created(){
    },
    methods:{
        //天气接口
        setWeather(){
           // 创建一个 Date 对象
            var now = new Date();
            // 获取当前年份
            var currentYear = now.getFullYear();
            // 获取当前月份（注意，月份是从0开始计数的，所以需要加1）
            var currentMonth = now.getMonth() + 1;
            // 获取当前日期
            var currentDate = now.getDate();
            //获取当前小时
            var currentHour = now.getHours();
            if(currentMonth<10){
              currentMonth='0' + currentMonth
            }
            if(currentDate<10){
              currentDate='0' + currentDate
            }
            let param = {
                qybms:'110000',
                fPeriod:currentYear + "-" + currentMonth + "-" + currentDate +" "+ currentHour +':00',
                tPeriod:currentYear + "-" + currentMonth + "-" + currentDate +" "+ currentHour +':00',
            }
            monitoringLeftApi.getWeatherHourData(param).then(res => {
                if(res.code == 200){
                    this.tq = res.data[0].sdtqInfos[0]
                    // console.log("111111",this.tq);
                    
                }
            })
        },
        //跳转到第二屏幕
        jump(){
            this.$router.push('/monitoringLeft2')
        },
        //跳转到详情
        goDetail(){
            this.$router.push(
                {
                    path:'/monitoringDetail',
                    query:{
                        id:this.mapObj.id
                    }
                }
            )
        },
        //加载地图
        setMap(){
                let czList = this.stationData
                // let czList = [
                //     {
                //         lng:116.1142,
                //         lat:39.7497,
                //         name:'北京市房山区燕山电站'
                //     },
                //     {
                //         lng:116.4798,
                //         lat:39.8734,
                //         name:'北京市朝阳区潘家园电站'
                //     },
                //     {
                //         lng:116.3712,
                //         lat:40.1664,
                //         name:'北京市昌平区北七家电站'
                //     },
                //     {
                //         lng:116.6832,
                //         lat:39.8814,
                //         name:'北京市通州区中关村电站'
                //     }
                // ]
              /**
                * 全局参数设置
                */
                minemap.domainUrl = '//10.56.4.2:21009';
                minemap.dataDomainUrl = '//10.56.4.2:21009';
                minemap.spriteUrl = '//10.56.4.2:21009/minemapapi/v2.1.0/sprite/sprite';
                minemap.serviceUrl = '//10.56.4.2:21009/service/';

                /**
                * appKey、solution设置
                */
                minemap.appKey = '16be596e00c44c86bb1569cb53424dc9';
                minemap.solution = 12877;

                /**
                * 初始化地图实例
                */
                this.map = new minemap.Map({
                    container: 'bmap',
                    hash:false,
                    style: '//10.56.4.2:21009/service/solu/style/id/12878', /*底图样式*/
                    center: ['116.42', '39.84'], /*地图中心点*/
                    zoom: 10, /*地图默认缩放等级*/
                    pitch: 0, /*地图俯仰角度*/
                    maxZoom: 17, /*地图最大缩放等级*/
                    minZoom: 3  /*地图最小缩放等级*/
                });
                czList.forEach(Element => {
                    let el = document.createElement('div');
                    el.id = 'marker';
                    let imgUrl = require('../../assets/images/monitoring/mapMarker.png')
                    el.style["background-image"] = 'url('+ imgUrl +')';
                    el.style["background-size"] = "cover";
                    el.style.width = "40px";
                    el.style.height = "40px";
                    el.name = Element.stationName
                    el.stationNumber = Element.stationNumber
                    el.propertyName = Element.propertyName
                    el.id = Element.id
                    // let el2 = document.createElement('div');
                    // el2.innerHTML = `<div class="pop-ups" v-if="`+ this.mapDialog +`">
                    // <div class="dialog-title">
                    //     <img src="../../assets/images/cockpit/mark.png" alt="" />
                    //     <p>{{mapObj.name}}</p>
                    // </div>
                    // <ul class="dialog-content">
                    //     <li class="year-electricity">
                    //     <div>
                    //         <span>5465.86</span>
                    //         <p>年总用电量 (GWh)</p>
                    //     </div>
                    //     </li>
                    //     <li class="dialog-form">
                    //     <div>管理中心:</div>
                    //     <p>{{mapObj.propertyName}}</p>
                    //     </li>
                    //     <li class="dialog-form">
                    //     <div>场站编码:</div>
                    //     <p>{{mapObj.stationNumber}}</p>
                    //     </li>
                    //     <li class="dialog-form">
                    //     <div>设备总数:</div>
                    //     <p>42</p>
                    //     </li>
                    //     <li class="dialog-form">
                    //     <div>当月用电量:</div>
                    //     <p>23541kWh</p>
                    //     </li>
                    //     <li class="dialog-form">
                    //     <div>昨日用电量:</div>
                    //     <p>5274kWh</p>
                    //     </li>
                    //     <li class="dialog-form">
                    //     <div>查看视频:</div>
                    //     <img style="margin-left: 16px" src="../../assets/images/cockpit/camera.png" alt="" />
                    //     </li>
                    //     <li>
                    //     <button style="cursor:pointer;" @click="goDetail()">查看详细 >></button>
                    //     </li>
                    // </ul>
                    // </div>`
                    // let popup = new minemap.Popup({closeOnClick: false, closeButton: false, offset: [0, 0]})
                    // .setDOMContent(el2)
                    // .addTo(this.map);
                    let markers = []
                    let lnglat = new minemap.LngLat(Element.longitude,Element.latitude)
                    let _marker = new minemap.Marker(el, {
                        offset:  [-20, -40],
                        name:Element.stationName,
                        stationNumber:Element.stationNumber,
                        propertyName:Element.propertyName,
                        id:Element.id
                    }).setLngLat(lnglat).addTo(this.map)
                    _marker.setExtData(el)
                    // _marker.setPopup(popup)
                    markers.push(_marker)
                   
                })
                this.map.on('click',this.onMouseClick)
                this.map.on('zoom',this.onZoom)
                this.map.on('movestart',this.onZoom)
        },
        //地图点击事件
        onMouseClick(e){
            this.mapDialog = false
            var lat = e.lngLat.lat
            var lng = e.lngLat.lng
            this.stationData.forEach(Element => {
                if(e.originalEvent.target.name == Element.stationName){
                    lng = Element.longitude
                    lat = Element.latitude
                }
            })

            this.map.panTo([lng,Number(lat)])
            let mapObj = {
                name:e.originalEvent.target.name,
                stationNumber:e.originalEvent.target.stationNumber,
                propertyName:e.originalEvent.target.propertyName,
                id:e.originalEvent.target.id
            }
            // if(e.originalEvent.target.name){
            //     this.mapDialog = true
            //     this.mapObj = mapObj
            // }
            if(e.originalEvent.target.id){
                monitoringLeftApi.getStationDetail({stationId:e.originalEvent.target.id}).then(res=>{
                    console.log(res);
                
                    if(e.originalEvent.target.name){
                        this.mapDialog = true
                        this.mapObj = res.data
                        this.mapObj.id = e.originalEvent.target.id
                        console.log(this.mapObj);
                    }
                })
            }
        },
        //地图定位事件
        mapCenter(e){
            this.mapDialog = false
            let lat = e.latitude
            let lng = e.longitude
            this.map.panTo([lng,Number(lat)])
            let mapObj = {
                name:e.stationName,
                stationNumber:e.stationNumber,
                propertyName:e.propertyName,
                id:e.id
            }
            // if(e.stationName){
            //     this.mapDialog = true
            //     // this.mapObj = mapObj
            // }
            if(e.id){
                monitoringLeftApi.getStationDetail({stationId:e.id}).then(res=>{
                    console.log(res);
                
                    if(e.stationName){
                        this.mapDialog = true
                        this.mapObj = res.data
                        this.mapObj.id=e.id
                        console.log(this.mapObj);
                    }
                })
            }
        },
        //地图缩放
        onZoom(){
            this.mapDialog = false
        },
        setchart1(){
            monitoringLeftApi.getNoticeList().then(res=>{
                this.List7=res.data.pop().list.splice(0,4)
                let noticePie=[]
                var noticeText=[]
                res.data.forEach(item=>{
                    if(item.total > 0){

                        let obj={
                            value:item.total,
                            name:item.noticeTypeName 
                        }
                        noticePie.push(obj)
                        noticeText.push(item.noticeTypeName)
                    }
                    })
                    console.log(noticeText);
                    let myChart = echarts.init(document.getElementById('two_footer'))
                    // 绘制图表
                    var option = {
                        color: ['#0CC076', '#17D2C7','#F4BF49','#F0803F','#09A52A','#929090', '#F15665','#176AD2','#17A8D2','#AE56F1','#E02629'],
                        legend: {
                          type: 'scroll',
                          orient: 'vertical',
                          icon:'circle',
                          left:240,
                          top: 0,
                          bottom: 20,
                          data: noticeText,
                          itemHeight:10,
                          textStyle:{
                              fontSize:10,
                              color:'#BCCAF3'
                          }
                        },
                        tooltip: {
                                trigger: 'item'
                            },
                        series: [
                        {
                            type: 'pie',
                            radius: ['60%', '75%'],
                            avoidLabelOverlap: false,
                            center:['100','85'],
                            label: {
                            show: false,
        
                            },
                            labelLine: {
                            show: true
                            },
                            itemStyle: {
                            borderWidth: 0,
                            borderColor: '#fff',
                            borderRadius: 0,
                            emphasis: {
                                scale: false  // 设置为 false，表示在 hover 时大小不改变
                            }
                            },
                            data:noticePie
                            // data: [ 
                            // { value: 8, name: '乘车通告' },
                            // { value: 12, name: '企业新闻' },
                            // { value: 10, name: '重要信息公式' },
                            // { value: 7, name: '大事件' },
                            // { value: 7, name: '统计资料' },
                            // { value: 6, name: '失物招领站' },
                            // { value: 6, name: '招标信息' },
                            // { value: 13, name: '乘客专区' },
                            // { value: 6, name: '员工风采' },
                            // { value: 5, name: '旅游北京' },
                            // ]
                        }
                        ]
                    };
                    myChart.setOption(option);
            })

        },
        setchart2(){
            let myChart2 = echarts.init(document.getElementById("one_echarts"));
            var distX = ''
            var distY = ''
            monitoringLeftApi.deviceType().then(res=>{
                distX = res.map(item=>item.positionName)
                distY=res.map(item=>item.num)
                // distY=[10,9]
                var option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    grid:{
                        left:160,
                        top:100,
                        bottom:20
                    },
                    xAxis: {
                    type: 'category',    
                    data: distX,
                    axisLabel: {
                        textStyle: {
                        color: "#C5D8FF", // 设置字体颜色
                        },
                    },
                    axisLine:{
                        show:false
                    },
                    axisTick:{
                        show:false
                    }
                    },
                    yAxis: {
                    name: "单位：个",
                    nameTextStyle: {
                        color: "#C5D8FF",
                        fontSize: 10,
                    },
                 
                    minInterval: 1, // 设置刻度间隔为1，确保只显示整数刻度
                    axisLabel: {
                        textStyle: {
                        color: "#C5D8FF", // 设置字体颜色
                        },
                    },
                    splitLine: {
                        show: false,
                    },
                    },
                    series: [
                    {
                        type: "bar",
                        barWidth: 10,
                        itemStyle: {
                        normal: {
                            barBorderRadius: [10, 10, 0, 0], // 设置柱状图圆角
                            color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                { offset: 0, color: "#0CC076" },
                                // { offset: 0.5, color: "#091b4d" },
                                { offset: 1, color: "#2AD58F" },
                            ],
                            global: false,
                            },
                        },
                        },
                        data: distY,
                    },
                    ],
                };
                // 使用刚指定的配置项和数据显示图表。
                myChart2.setOption(option);
            })
            // 指定图表的配置项和数据
        },
        setchart3(){
            let myChart = echarts.init(document.getElementById('two_echarts'))
            // 绘制图表
            var distName = []
            var distValue = []
            monitoringLeftApi.positionType().then(res=>{
                res.forEach(item=>{
                    distName.push(item.positionName)
                    let obj={
                        value:item.ratio,
                        name:item.positionName
                    }
                    distValue.push(obj)
                })
                // console.log(distValue);
                var option = {
                    color: ['#0CC076','#176AD2','#F4BF49','#F0803F'],
                    tooltip: {
                    trigger: 'item'
                },
                    legend: {
                      type: 'scroll',
                      orient: 'vertical',
                      icon:'circle',
                      left:200,
                      top: 0,
                      bottom: 20,
                      data: distName,
                      itemHeight:10,
                      textStyle:{
                          fontSize:10,
                          color:'#BCCAF3'
                      },
                    },
                    series: [
                    {
                        type: 'pie',
                        radius: ['60%', '72%'],
                        avoidLabelOverlap: false,
                        center:['102','85'],
                        label: {
                        show: false,
    
                        },
                        labelLine: {
                        show: true
                        },
                        itemStyle: {
                        borderWidth: 0,
                        borderColor: '#fff',
                        borderRadius: 0,
                        emphasis: {
                            scale: false  // 设置为 false，表示在 hover 时大小不改变
                        }
                        },
                        data: distValue
                    }
                    ]
                };
                myChart.setOption(option);
            })
        },
        //设备寿命统计切换
        dictChange(){
            this.setchart4() 
        },
        setchart4(){
            let myChart = echarts.init(document.getElementById('three_echarts'))
            // 绘制图表
            var dataText =[]
            var dataValue=[]
            monitoringLeftApi.deviceLifeTime({type:this.dictType}).then(res=>{
                
                
                dataText=res.map(item=>item.period)
                res.forEach(item=>{
                    let obj={
                        value:item.ratio,
                        name:item.period,
                    }
                    dataValue.push(obj)
                })
                // dataValue.sort(customSort)
                console.log(dataValue);
                var option = {
                    color: ['#0CC076','#176AD2','#F4BF49','#F0803F','#176AD2','#F4BF49'],
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                      type: 'scroll',
                      orient: 'vertical',
                      icon:'circle',
                      left:200,
                      top: 40,
                      bottom: 20,
                      data: dataText,
                      itemHeight:10,
                      textStyle:{
                          fontSize:10,
                          color:'#BCCAF3'
                      }
                    },
                    series: [
                    {
                        type: 'pie',
                        radius: ['70%', '90%'],
                        avoidLabelOverlap: false,
                        center:['102','85'],
                        label: {
                        show: false,
    
                        },
                        labelLine: {
                        show: true
                        },
                        itemStyle: {
                        borderWidth: 0,
                        borderColor: '#fff',
                        borderRadius: 0,
                        emphasis: {
                            scale: false  // 设置为 false，表示在 hover 时大小不改变
                        }
                        },
                        // data: [ 
                        // { value: 5, name: '2003年以前' },
                        // { value: 26, name: '2003-2008' },
                        // { value: 51, name: '2008-2012' },
                        // { value: 12, name: '2012-2019' },
                        // { value: 6, name: '2019-今' },
                        // ]
                        data:dataValue
                    }
                    ]
                };
                console.log(dataValue);
                myChart.setOption(option);
             

            })
        },
        //分地区场站统计
        stationChange(value){
            console.log('1111',this.value);
            this.setchart5()
        },
        setchart5(){
            let myChart5 = echarts.init(document.getElementById("four_echarts"));
            let obj={type:String(this.value)}
            console.log(typeof(obj.type));
            var dataX=[]
            var dataY=[]
            monitoringLeftApi.areaStation(obj).then(res=>{
                dataX=res.map(item=>item.name)
                dataY=res.map(item=>item.num)
                
                // 指定图表的配置项和数据
                var option = {
                    tooltip: {},
                    grid:{
                        left:140,
                        top:30,
                        bottom:60
                    },
                    xAxis: {
                    type: 'category',    
                    data: dataX,
                    axisLabel: {
                        interval:0,
                        textStyle: {
                        color: "#C5D8FF", // 设置字体颜色
                        },
                        // formatter:function(value){
                        //     return value.split('').join('\n')
                        // }
                    },
                    axisLine:{
                        show:false
                    },
                    axisTick:{
                        show:false
                    }
                    },
                    yAxis: {
                    name: "单位：个",
                    nameTextStyle: {
                        color: "#C5D8FF",
                        fontSize: 10,
                    },
                    // data: [0,1000,2000,3000,4000,5000,6000],
                    minInterval: 1,
                    axisLabel: {
                        textStyle: {
                        color: "#C5D8FF", // 设置字体颜色
                        },
                    },
                    splitLine: {
                        show: false,
                    },
                    },
                    series: [
                    {
                        type: "bar",
                        barWidth: 10,
                        itemStyle: {
                        normal: {
                            barBorderRadius: [10, 10, 0, 0], // 设置柱状图圆角
                            color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                { offset: 0, color: "#F2BE49" },
                                // { offset: 0.5, color: "#091b4d" },
                                { offset: 1, color: "#CB9419" },
                            ],
                            global: false,
                            },
                        },
                        },
                        data: dataY,
                    },
                    ],
                };
                myChart5.setOption({
                    dataZoom: [
                        {
                            type: 'slider',    // 数据缩放类型为滑动条
                            start: 0,          // 开始位置（范围为 0 到 100）
                            end: 20            // 结束位置（范围为 0 到 100）
                        },
                        {
                            type: 'inside',    // 内置的数据缩放类型，鼠标滚轮缩放
                            start: 0,          // 开始位置（范围为 0 到 100）
                            end: 100            // 结束位置（范围为 0 到 100）
                        }
                        ]
                    });
    
                // 使用刚指定的配置项和数据显示图表。
                myChart5.setOption(option);
            })
        },
        //tiaozhuan 
        goHome(path){
            this.$router.push({
                name:path
            })
        },
        //tuichu 
        loginOut(){
            sessionStorage.clear();
            localStorage.clear();
            this.$router.replace('/login');
        },
        //获取能源监控总天数
        getTime(){
            const specifiedDate = new Date('2024-07-01');
            const currentDate = new Date();
            const specifiedTimestamp = specifiedDate.getTime();
            const currentTimestamp = currentDate.getTime();
            let millisecondsDiff = currentTimestamp - specifiedTimestamp;
            let daysDiff = Math.max(0, Math.floor(millisecondsDiff / (1000 * 60 * 60 * 24)));
            daysDiff = String(daysDiff).padStart(5, '0');
            this.timeDays=daysDiff.split('').map(Number)
            // console.log("当前天数减去 2024年6月1日的天数差异为：" + typeof(daysDiff) + " 天");
        },
        //分中心点击
        fzxClick(item){
            if(this.fzxId==item.id){
                this.fzxId=null
            }else{
                this.fzxId=item.id
            }
            this.stationDialog()
        },
        //产权单位点击
        cqdwClick(item){
            console.log(item);
            if(this.cqdwId==item){
                this.cqdwId=null
            }else{
                this.cqdwId=item
            }
            this.stationDialog()
        },
        //场站选择
        stationSearchClick(item){
            this.stationId=item.id
            this.sxDialog=false
            this.mapCenter(item)
            if( !this.sxDialog){
                this.fzxId=null
                this.cqdwId=null
            }
        },
        //打开场站弹窗
        sxDialogShow(){
            this.sxDialog=! this.sxDialog
            if( !this.sxDialog){
                this.fzxId=null
                this.cqdwId=null
            }else{
                this.mapDialog=false
            }
        },
        // 搜索场站
        searchStation(){
            this.stationDialog()
        },
        //获取场站
        stationDialog(){
            let obj={
                companyId:this.fzxId,
                propertyUnit:this.cqdwId,
                stationName:this.stationName,
            }
            monitoringLeftApi.stationDialog(obj).then(res=>{
                this.fzxList=res.data.companyInfoList
                this.cqdwList=res.data.propertyUnits
                this.stationData=res.data.stationInfos
                this.setMap()
            })
        },
        //用能情况统计
        energyStations(){
            monitoringLeftApi.energyStations().then(res=>{
                    this.statistics=res.data
                if (this.List) {
                    // 修改第一个元素的 grade
                    if (this.List[0]) {
                        this.$set(this.List[0], 'grade', this.statistics.companyAmount);
                    }
                    // 修改第二个元素的 grade
                    if (this.List[1]) {
                        this.$set(this.List[1], 'grade', this.statistics.stationAmount);
                    }
                } 
                if (this.List2) {
                    // 修改第一个元素的 grade
                    if (this.List2[0]) {
                        this.$set(this.List2[0], 'grade',  parseFloat(this.statistics.co2.toFixed(3)));
                    }
                    // 修改第二个元素的 grade
                    if (this.List2[1]) {
                        this.$set(this.List2[1], 'grade', parseFloat(this.statistics.equivalentTreePlanting.toFixed(3)));
                    }
                } 
                if (this.List4) {
                    // 修改第一个元素的 grade
                    if (this.List4[0]) {
                        this.$set(this.List4[0], 'name', this.statistics.yearTotalPower.toFixed(2));
                    }  
                } 
                if (this.List5) {
                    // 修改第一个元素的 grade
                    if (this.List5[0]) {
                        this.$set(this.List5[0], 'name',  this.statistics.monthTotalPower.toFixed(2));
                    }  
                } 
                if (this.List6) {
                    // 修改第一个元素的 grade
                    if (this.List6[0]) {
                        this.$set(this.List6[0], 'name', this.statistics.dayTotalPower.toFixed(2));
                    }  
                } 
                // 确保页面已经更新完毕后再进行操作
            })
        },
        //使用字典获取设备寿命情况统计
        queryDictionary(){
            monitoringLeftApi.queryDictionary({ dictCode: "position_type" }).then(res=>{
                this.dictList=res.data
            })
        },
        currentTime() {
      setInterval(this.getDate, 500)
    },
    getDate() {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let ms = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds()
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = "星期一"
      } else if (week == 2) {
        this.nowWeek = "星期二"
      } else if (week == 3) {
        this.nowWeek = "星期三"
      } else if (week == 4) {
        this.nowWeek = "星期四"
      } else if (week == 5) {
        this.nowWeek = "星期五"
      } else if (week == 6) {
        this.nowWeek = "星期六"
      } else {
        this.nowWeek = "星期日"
      }
      _this.nowTime = this.fillZero(hh) + ":" + mf + ":" + ms 
      _this.nowDate = this.fillZero(yy) + "年" + this.fillZero(mm) + "月" + this.fillZero(dd) + "日"
    },
    // 给时间补零
    fillZero(str) {
      var realNum
      if (str < 10) {
        realNum = "0" + str
      } else {
        realNum = str
      }
      return realNum
    },

    },
    beforeDestroy() {
    if (this.getDate) {
      console.log("销毁定时器")
      clearInterval(this.getDate) // 在Vue实例销毁前，清除时间定时器
    }
  },
}
</script>
<style scoped>
    .el-select{
        pointer-events: auto;
    }
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .pop-ups {
        width: 265px;
        height: 386px;
        background: url("../../assets/images/monitoring/maptc.png") no-repeat center;
        background-size: cover;
        padding-top: 25px;
        box-sizing: border-box;
        position: fixed;
        top: 300px;
        right: 660px;
        z-index:99999999;
    }
    .pop-ups p {
        display: inline-block;
    }
    .dialog-title {
        height: 24px;
        display: flex;
        align-items: center;
        margin: 0 0 0 28px;
    }
    .dialog-title img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
    .dialog-title p {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffc74b;
    }
    .dialog-form {
        display: flex;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #d9e3ff;
        margin-bottom: 9px;
        box-sizing: border-box;
    }
    .dialog-form p {
        margin:0;
    }
    .dialog-form div::after {
        /* content: ":"; */
        margin: 0 3px;
    }
    .year-electricity {
        width: 212px;
        height: 70px;
        background: url("../../assets/images/electricity/year-background.png") no-repeat center;
        background-size: cover;
        margin: 0 29px 13px 0px;
        position: relative;
    }

    .year-electricity div {
        position: absolute;
        top: 12px;
        left: 69px;
    }

    .year-electricity span {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #40ecc2;
    }

    .year-electricity p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #d9e3ff;
    }
    .dialog-content {
  margin: 21px 0 0 25px;
}
.dialog-content li {
  display: flex;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d9e3ff;
  margin-bottom: 12px;
}
.dialog-content div::after {
  /* content: ":"; */
  margin: 0 3px;
}
.dialog-content button {
  width: 206px;
  height: 38px;
  background: #3357c4;
  border-radius: 2px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d9e3ff;
  text-align: center;
  line-height: 38px;
  border: 0;
}
    .right_nav{
        width:30px;
        height:30px;
        background: url('../../assets/images/monitoring/rightNav.png') no-repeat;
        position: fixed;
        z-index: 99999;
        right: 0;
        top: 5.5rem;
        cursor: pointer;
    }
    .total-electricity {
        position: fixed;
        top: 1.5rem;
        left: 8.2rem;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #d9e3ff;
    }
    
    .total-electricity .text {
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .text span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #d9e3ff;
        margin-left: 11px;
    }
    .total-electricity img{
        vertical-align: middle;
    }
    .total {
        display: flex;
        margin-top: 16px;
    }

    .total li {
        width: 41px;
        height: 72px;
        background: url("../../assets/images/electricity/number-background.png") no-repeat center;
        background-size: cover;
        margin-right: 13px;
        font-size: 50px;
        font-family: DIN;
        font-weight: 400;
        color: #e9f1fa;
        text-align: center;
        line-height: 72px;
    }

    .total li:last-child {
        margin-right: 0;
    }

    ::v-deep .el-input--suffix .el-input__inner{
        background: transparent !important;
        height: 0.25rem;
        border:none;
        color: #AED6FF;
    }
    ::v-deep .el-input__icon {
        height: 40px; 
        position: relative;
        top: -7px; 
    }
    #monitoringLeft{
        background: url('../../assets/images/monitoring/monitoringLeftbg.png') no-repeat;
        height: 1080px;
        background-size: cover;
        position: relative;
    }
    .left_header{
        width:100%;
        height:1.08rem;
        background: url('../../assets/images/monitoring/monitoringLefttop.png') no-repeat;
    }
    .left_main{
        width:5.71rem;
        height:9.36rem;
        background: url('../../assets/images/monitoring/leftMain2.png') no-repeat;
        float:left;
        position: absolute;
        z-index:9999;
        pointer-events: none;
    }
    .center_main{
        /* float: left; */
        /* width: 7.5rem; */
        /* height: 6rem; */
        /* width:100%; */
        width: 1920px;
        position: absolute;
        /* left: 4.71rem; */
        top: 1.08rem;
        height: 1080px;
        /* border-radius: 6rem; */
    }
    .main_cz{
        width:0.52rem;
        height:0.67rem;
        /* background: url('../../assets/images/monitoring/dtcz.png') no-repeat; */
        position: fixed;
        left: 5.9rem;
        top: 1.58rem;
        cursor: pointer;
        z-index: 9999;
    }
    .center_main .main_tq{

    }
    .main_czsx{
        width:6.9rem;
        height:7.14rem;
        background: url('../../assets/images/monitoring/czsx.png') no-repeat;
        position: fixed;
        left: 6.6rem;
        top: 1.58rem;
        padding:0.6rem 0.25rem 0 0.25rem;
        box-sizing: border-box;
        z-index: 9999;
    }
    .main_czsx .czsx_title{
        margin-bottom: 0.1rem;
        font-size:14px;
        color:#AED6FF;
    }
    .main_czsx .czsx_div{
        height:1.5rem;
        margin-bottom:0.1rem;
        overflow: auto;
        width: 6.5rem;
    }
    .czsx_div::-webkit-scrollbar {
    width: 4px;
    background-color: #0A1857;
    }

    .czsx_div::-webkit-scrollbar-thumb {
    background-color: #003d74;
    border-radius: 5px;
    }

    .czsx_div::-webkit-scrollbar {
        width: 4px;
        background-color: #0A1857;
    }
    .czsx_div div{
        width: 1.5rem;
        margin-right:0.1rem;
        margin-bottom:0.1rem;
        height: 0.3rem;
        line-height: 0.3rem;
        border-radius: 2px;
        font-size:12px;
        float:left;
        text-align: center;
        color:#AED6FF;
        background-color: rgba(14,100,217,0.11);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        /* background-color: #0E64D9; */
    }
    .czsx_title img{
        vertical-align: bottom;
    }
    .right_main{
        pointer-events: none;
        width:5.71rem;
        height:9.36rem;
        background: url('../../assets/images/monitoring/rightMain2.png') no-repeat;
        /* float:right; */
        right:0;
        position: absolute;
        z-index:99999;
    }
    .monitoringFooter{
        height:1.38rem;
        margin-top: -1rem;
        background: url('../../assets/images/monitoring/monitoringLeftfooter.png') no-repeat;
        position: absolute;
        bottom: 0;
        width: 100%;
        pointer-events: none;
    }
    .header_left{
        font-size:12px;
        color:#BCCAF3;
        position: absolute;
        left: 0.5rem;
        top: 0.4rem;
    }
    .header_right{
        font-size:12px;
        color:#BCCAF3;
        position: absolute;
        right: 0.5rem;
        top: 0.4rem;
    }
    .header_left img,.header_right img{
        cursor:pointer;
        vertical-align: bottom;
        margin-right:0.1rem;
    }
    .header_left span,.header_right span{
        cursor:pointer;
        margin-right:0.1rem;
    }
    .main_one{
        width:5.71rem;
        height:4.58rem;
        margin-bottom:0.17rem;
        overflow:hidden;
    }
    .one_div{
        padding-top:0.73rem;
        padding-left:0.14rem;
        height: 0.61rem;
        margin-bottom:0.13rem;
    }
    .main_one .two_div{
        height: 0.61rem;
        padding-left: 0.14rem;
        margin-bottom: 0.14rem;
    }
    .main_one .div_main{
        float: left;
        margin-right: 0.25rem;
        width:1.81rem;
        height:0.61rem;
        padding-left:0.75rem;
        padding-top:0.13rem;
        box-sizing: border-box;
    }
    .main_two{
        /* pointer-events: auto; */
    }
    .main_two .div_main{
        font-size:0.12rem;
        color:#BCCAF3;
    }
    .main_two .two_div{
        height:0.32rem;
        width:3.54rem;
        /* background-color: rgba(12,62,146,.11); */
        padding:0.06rem 0.25rem 0.13rem 0.22rem;
        box-sizing: border-box;
        margin-bottom:0.1rem;
    }
    .three_div{
        height:0.41rem;
        padding-left: 0.14rem;
        margin-bottom:0.1rem;
    }
    .four_div{
        height:0.35rem;
        padding-left: 0.14rem;
        margin-bottom:0.2rem;
    }
    .three_main{
        float:left;
        margin-right: 0.24rem;
    }
    .four_main{
        float:left;
        margin-right: 0.2rem;
        display: flex;
    }
    .three_main img,.four_main img{
        float:left;
        margin-right: 0.1rem;
    }
    .three_main span{
        font-size: 0.12rem;
        color:#D9E3FF;
    }
    .main_two{
        height: 4.63rem;
        padding-left: 0.14rem;
        padding-top:0.69rem;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
    }
    #two_footer{
        height:2.04rem;
        width:5.52rem;
        background: url('../../assets/images/monitoring/xwzxbg.png') no-repeat;
    }
    #one_echarts{
        width:5.71rem;
        height:2.5rem;
        pointer-events: auto;
    }
    #two_echarts{
        width:5.71rem;
        height:2.04rem;
        margin-left: 1.6rem;
        background: url('../../assets/images/monitoring/pdxsbg.png') no-repeat;
        pointer-events: auto;
    }
    #three_echarts{
        width: 5.71rem;
        height: 1.7rem;
        margin-left: 1.8rem;
       
        pointer-events: auto;
    }
    .backg{
        background: url('../../assets/images/monitoring/byqnxbg.png') no-repeat;
    }
    .backg1{
        background: url('../../assets/images/monitoring/GYC.png') no-repeat;
    }
    .backg2{
        background: url('../../assets/images/monitoring/BYQ.png') no-repeat;
    }
    .backg3{
        background: url('../../assets/images/monitoring/DYC.png') no-repeat;
    }
    .backg4{
        background: url('../../assets/images/monitoring/ZLP.png') no-repeat;
    }
    .backg5{
        background: url('../../assets/images/monitoring/QT.png') no-repeat;
    }
    #four_echarts{
        pointer-events: auto;
        width:5.71rem;
        height:2rem;
    }
    .one_title{
        width:5.71rem;
        margin-left: 1.6rem;
        padding-left:0.42rem;
        padding-top: 0.08rem;
        font-size:14px;
        color:#D9E3FF;
        height:0.32rem;
        background: url('../../assets/images/monitoring/pdxsqktj.png') no-repeat;
        box-sizing: border-box;
    }
.search {
    float:right;
    display: flex;
    margin: 7px 0 13px 0;
}
.search :deep() input {
  width: 480px;
  height: 30px;
  background-color: rgba(14, 100, 217, 0.11);
  color: #aed6ff;
  font-family: Microsoft YaHei;
  font-size: 12px;
  border: 0;
  box-sizing: border-box;
}
.search :deep() button {
  width: 75px;
  height: 30px;
  background-color: #176ad2;
  color: #aed6ff;
  font-family: Microsoft YaHei;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  padding: 0;
  border: 0;
  border-radius: 0;
  margin-left: -10px;
}
.screen-subtitle {
  display: flex;
  float:left;
  align-items: center;
  margin: 12px 0 13px 0;
}
.screen-subtitle img {
  width: 20px;
  height: 20px;
}
.main_tq{
    position: fixed;
    right: 5.9rem;
    top: 1.58rem;
}
.tq_feng{
    width:0.51rem;
    height:0.67rem;
    background: url('../../assets/images/monitoring/feng.png') no-repeat;
    margin-bottom:0.1rem;
    position: relative;
}
.tq_feng .feng_name{
    height:0.14rem;
    font-size:0.12rem;
    position: absolute;
    bottom: 11px;
    text-align: center;
    width: 100%;
}
.tq_yu{
    width:0.51rem;
    height:0.67rem;
    background: url('../../assets/images/monitoring/yu.png') no-repeat;
}
.custom-select>>>.el-select-dropdown {
  background: #041C4C !important;
  border: 1px solid #09295b;
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.hover {
  background: #041C4C !important;
  color: #fff;
}

::v-deep .el-select-dropdown__item {
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.selected {
  color: #fff;
}
::v-deep .el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 0;
  border-bottom-color: #041C4C;
}
.searchText{
    color: #ffc74a;
}
</style>
